<template>
    <div class="sys-select">
        <a-select v-show="isEditSelect" ref="sysSelect" :show-search="showSearch" :default-value="defaultValue" v-model="selectValue" :style="{width: width}" @focus="handleClickFuc" @blur="confirmModify" @change="handleChange">
            <a-select-option :value="item" v-for="(item, index) in selectOptions" :key="index">{{item}}</a-select-option>
        </a-select>
        <div v-show="!isEditSelect" class="select-text" ref="sysTextSelect" :style="{width: width}" @click="editSelect">{{selectValue}}</div>
    </div>
</template>

<script>
export default {
    name: 'YeahagencySysselect',
    props: {
        width: {
            type: String,
            default: '110px'
        },
        defaultValue: {
            type: String,
            default: ''
        },
        selectOptions: {
            type: Array,
            default: () => {}
        },
        isShowEdit: {
            type: Boolean,
            default: false
        },
        showSearch: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            selectValue: this.defaultValue,
            isEditSelect: this.isShowEdit,
        };
    },

    watch: {
        selectValue(newValue, oldValue) {
            this.$emit('select-click', oldValue);
        }
    },

    created() {
        
    },

    mounted() {
        
    },

    methods: {
        editSelect() {
            this.isEditSelect = true
        },
        confirmModify() {
            let dom = this.$refs.sysSelect;
            dom.$el.style.borderColor = '#BFBFBF'
            this.isEditSelect = false

            // let textDom = this.$refs.sysTextSelect;
            // textDom.style.borderColor = '#BFBFBF'
        },
        handleChange(val) {
            this.selectValue = val
            this.$emit('change', val);
        },
        repeatValiteFuc() {
            // let dom = this.$refs.sysSelect;
            // let textDom = this.$refs.sysTextSelect;
            // dom.$el.scrollIntoView({block: "center", behavior: "smooth",})
            // dom.$el.style.borderColor = 'red'
            // textDom.style.borderColor = 'red'
        },
        handelValite() {
            if (!this.selectValue) {
                this.isEditSelect = true
                let dom = this.$refs.sysSelect;
                dom.$el.scrollIntoView({block: "center", behavior: "smooth",})
                dom.$el.style.borderColor = 'red'
            }
        },
        handleClickFuc() {
            // this.$emit('select-click', this.selectValue);
        },
    },
};
</script>

<style lang="less" scoped>
    .sys-select {
        .select-text {
            padding-left: 10px;
            width: 120px;
            height: 32px;
            border: 1px solid transparent;
            line-height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .ant-select-selection {
            border: none;
        }
    }
</style>
<style lang="less">
    .sys-select {
        .ant-select {
            border: 1px solid #BFBFBF;
            border-radius: 2px;
        }
        .ant-select-selection {
            border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Basic/sysSelect.vue